require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")

$ = window.$ = window.jQuery = require('jquery');
require("sticky-kit/dist/sticky-kit");
require("slick-carousel/slick/slick");
require("packs/script");
